import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M14 7l-5 5 5 5V7z"
}), 'ArrowLeft');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/ArrowLeft.js
// module id = 2108
// module chunks = 2